import React from "react";
import Section from "../Section/Section";
import ServiceCard from "../ServiceCard/ServiceCard";

import { ourService } from "../../constants/home/ourService";
import { ServiceCards } from "./OurService.styled";
import { useTranslation } from "react-i18next";
import useDevice from "../../hooks/useDevice";

const OurServiceSection: React.FC = () => {
  const { t } = useTranslation();
  const { isDesktop } = useDevice();
  return (
    <Section
      header={t("pages.home.ourServices.title")}
      text={t("pages.home.ourServices.text")}
      textFontSize={isDesktop ? "1rem" : "0.9rem"}
      leftSideContentStyle={{
        maxWidth: "770px",
      }}
    >
      <ServiceCards>
        {ourService.map((service) => (
          <ServiceCard
            key={service.id}
            title={service.title}
            imageUrl={service.imageUrl}
            href={service.ctaLink}
            maxWidth={service.maxWidth}
          />
        ))}
      </ServiceCards>
    </Section>
  );
};

export default OurServiceSection;
